import qs from 'querystring';

import _isEqual from 'lodash/isEqual';

interface ILinkParams {
  queryParams?: Record<string, any>;

  [name: string]: any;
}

const paramRegExp = /(:[^\/&\?]*\??)(\/|$)/g;

export const addInitialSlash = (str) => (str.match(/^\//) ? str : `/${str}`);

export const toString = (params: Record<string, any>, prefix = '?') => {
  const queryString = qs.stringify(params);

  return queryString ? prefix + queryString : '';
};

export const replaceWithParams = (pattern, params) => {
  const str = pattern.replace(/(:[a-zA-z\d]*(\([^/]*\))?)/g, (match, p1: string) => {
    const value = params[p1.replace(/:|(\(.*\))/g, '')];

    if (!value) {
      return match;
    }
    return value.toString(); // match.replace(p1, value.toString());
  });

  return str.replace(paramRegExp, '');

  // Object.keys(params)
  // .reduce(
  //   (acc, param) =>
  //     // acc.replace(new RegExp(`:${escapeRegExp(param)}\\??(?=(\\/|$|\\?))`), params[param]),
  //     acc.replace(new RegExp(`:${param}(\\(.*\\))?/`), params[param]),
  //   pattern,
  // )
  // .replace(paramRegExp, '');
};

export const removeDefaultsProperties = (target, defaults) => {
  target = { ...target };

  Object.keys(target).forEach((key) => {
    if (_isEqual(target[key], defaults[key])) {
      delete target[key];
    }
  });

  return target;
};

export const splitProperties = (isLeft, obj) => {
  return Object.entries(obj).reduce(
    ([left, right], [k, v]) => (isLeft(v, k) ? [{ ...left, [k]: v }, right] : [left, { ...right, [k]: v }]),
    [{}, {}],
  );
};

export const createLinkProps = (page: string = '', pattern: string = '', params: ILinkParams = {}) => {
  const [
    inlineParams,
    {
      // @ts-ignore
      queryParams = {},
      ...restParams
    },
  ] = splitProperties((_, key) => pattern.match(`:${key}`), params);

  return {
    ...restParams,
    href: `${addInitialSlash(page)}${toString({ ...queryParams, ...inlineParams })}`,
    as: `${replaceWithParams(pattern, inlineParams)}${toString(queryParams)}`,
  };
};
